import { Action } from "redux";
import { Room, ThunkAction } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { showAlert } from "./Alerts.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["GET_ROOMS_START", "GET_ROOMS_SUCCESS"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type GetRoomsStart = ActionBase<"GET_ROOMS_START">;
type GetRoomsSuccess = ActionBase<"GET_ROOMS_SUCCESS"> & { rooms: Room[] };

export type RoomsAction = GetRoomsStart | GetRoomsSuccess;

export const isRoomsAction = (action: Action): action is RoomsAction =>
  isActionType(action, ActionTypeKeys);

export const getRooms =
  (siteId: string): ThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const loadState = getState().loadStates.rooms;
    if (loadState !== "unloaded" && loadState !== undefined) {
      return Promise.resolve();
    }

    dispatch(getRoomsStart());

    try {
      const { data } = await fetch({
        dispatch,
        languageId: "de",
        authorize: false,
      }).get<Room[]>(`sites/${siteId}/rooms`);
      dispatch(getRoomsSuccess(data));
    } catch (error) {
      dispatch(
        showAlert("Beim Laden der Zimmer-Daten ist ein Fehler aufgetreten!"),
      );
      throw error;
    }
  };

const getRoomsStart = (): GetRoomsStart => ({ type: "GET_ROOMS_START" });

const getRoomsSuccess = (rooms: Room[]): GetRoomsSuccess => ({
  type: "GET_ROOMS_SUCCESS",
  rooms,
});
